import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem,
} from "../../../common/component/Index";
import i18n from "../../../../../constants/initLng";
import DEFINE, { PATHS, UPLOAD_DIRECTORY, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import { message } from 'antd';
import { isEqual, get, debounce, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Hotel from '../../../../../models/Hotel';
import Wrapper from './../../../common/component/Wrapper';
import Button from './../../../common/component/Button';
import BasicInfo from './BasicInfo';
import AddressInfo from './AddressInfo';
import { getProvinceByName } from '../../../../../models/Province';
import { cloneDeep } from 'lodash'

import { getNapasReconEmailConfig, updateNapasReconEmailConfig } from '../../../../../services/napasReconEmailService';

import './HotelDetail.less';
import TranslateButton from '../../../common/component/TranslateButton';
import AutoTranslate from 'containers/backend/common/component/AutoTranslate/AutoTranslate';

let permisionRateActions = [];
let permisionBookablePackageRateActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    isSubmit: false,
    isGetItem: false,
    validation: {}
};

export default class HotelDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            hotel: this.props.hotelState.detail.hotel,
            uploadFiles: [],
            tagGroups: this.props.hotelState.tagGroups,
            napasReconEmail: undefined,
        };
        this.basicInfoRef = React.createRef()
    }

    componentDidMount() {
        this.initDetail()
        this.props.getListAmenities();
        permisionRateActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATEPLAN);
        permisionBookablePackageRateActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.BOOKABLEPACKAGERATES);
    }

    componentWillUnmount() {
        this.props.setHotelDetail(new Hotel())
        this.props.setTagGroupDetailSku([])
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.hotelState.detail.hotel && !isEqual(nextProps.hotelState.detail.hotel, this.props.hotelState.detail.hotel)) {
            this.setHotelDetail(nextProps.hotelState.detail.hotel)
        }
        if (nextProps.uploadState.file && !isEqual(nextProps.uploadState.file, this.props.uploadState.file)) {
            this.processUploadedFiles(nextProps.uploadState.file);
        }
        if (nextProps.hotelState.tagGroups && !isEqual(nextProps.hotelState.tagGroups, this.props.hotelState.tagGroups)) {
            this.setDataGroupTagDetail(nextProps.hotelState.tagGroups);
            const tagsGroupChange = (nextProps.hotelState.tagGroups || []).map(item => {
                return {
                    name: item.name,
                    tagGroupDetailId: item.id,
                    skuId: item.tagGroupDetailSkus?.[0]?.skuId,
                    isActiveListing: item.tagGroupDetailSkus?.[0]?.isActiveListing
                }
            })
            this.setState({ tagGroups: tagsGroupChange })
        }
    }

    render() {
        const { t, uploadState, hotelState, generalState, locationState, amenityState } = this.props;
        const { isFetching } = hotelState;
        const locations = locationState.dataList;
        const { action, isSubmit, isGetItem, validation, hotel, tagGroups } = this.state;
        const { amenities } = amenityState;

        return (
            <LoadingComponent spinning={isFetching || generalState.isFetching || isSubmit}>
                <PageListComponent className="hotel-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'hotels'}
                        titleHeader={action === DETAIL_ACTIONS.CREATE
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.hotel.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.hotel.title')}`.toLowerCase()))
                        }
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={hotel.translations}
                                current={hotel.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChangeDetail('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        activeComponent={'SWITCH'}
                        onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                        titleActiveComponent={hotel.isActive ? t(`item.hotel.active`) : t(`item.hotel.deActive`)}
                        submitButtonRight={true}
                        statusActiveName={`isActive`}
                        statusActive={hotel.isActive}
                        additionalButton={this.renderFooterButtons()}
                    >
                        <Wrapper className='flex'>
                            <Wrapper className='col-md-6 basic-section'>
                                <BasicInfo hotel={hotel}
                                    action={action}
                                    ref={this.basicInfoRef}
                                    napasReconEmail={this.state.napasReconEmail}
                                    onChangeNapasReconEmail={this.onChangeNapasReconEmail}
                                    uploading={uploadState.isFetchingMultiple}
                                    validation={validation}
                                    onChange={this.onChangeDetail}
                                    onUploadImage={this.onUploadImages}
                                    onRemoveImage={this.removeImages}
                                    amenities={amenities} />
                            </Wrapper>
                            <Wrapper className='col-md-6 address-section'>
                                <AddressInfo hotel={hotel}
                                    action={action}
                                    locations={locations}
                                    provinces={generalState.provinces}
                                    validation={validation}
                                    onSelectPlace={this.onSelectPlace}
                                    onChange={this.onChangeDetail}
                                    tagGroups={tagGroups}
                                    onChangeTags={this.onChangeTags} />
                            </Wrapper>
                        </Wrapper>
                        {action === DETAIL_ACTIONS.UPDATE && (
                            <AutoTranslate
                                className="wrapper-full"
                                languageCode={hotel?.languageCode || 'vi-VN'}
                                onChange={this.onChangeDetail}
                                targetLanguage={hotel?.targetLanguage}
                            />
                        )}
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    renderFooterButtons() {
        const { action, hotel } = this.state;

        return (
            <Wrapper className="footer-manage-buttons">
                {action !== DETAIL_ACTIONS.TRANSLATE &&
                    <Fragment>
                        <Button className="btn mr-2" icon="bars" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageRoomTypes}>{this.props.t(`navigation.roomTypes`)}</Button>
                        {
                            !hotel.isBeachVilla &&
                            <Button className="btn mr-2" icon="dollar" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageCustomPrices}>
                                {this.props.t(`navigation.customPrices`)}
                            </Button>
                        }
                        {
                            permisionRateActions && permisionRateActions.allowView &&
                            <Button className="btn mr-2" icon="dollar" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageRates}>
                                {this.props.t(`navigation.rates`)}
                            </Button>
                        }
                        {
                            permisionBookablePackageRateActions && permisionBookablePackageRateActions.allowView && !hotel.isBeachVilla &&
                            <Button className="btn mr-2" icon="container" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageBookablePackageRates}>
                                {this.props.t(`navigation.bookablePackageRates`)}
                            </Button>
                        }
                        {
                            !hotel.isBeachVilla &&
                            <Button className="btn mr-2" icon="logout" onClick={this.onClickRateCompare}>
                                {this.props.t(`navigation.rateCompare`)}
                            </Button>
                        }
                    </Fragment>
                }
            </Wrapper>
        )
    }

    initDetail() {
        const { match, hotelState } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            const hotel = find(hotelState.hotels, h => h.id === id);
            if (hotel) this.setHotelDetail(hotel);
            this.props.getHotelDetail(id);
            this.getNapasReconEmail(id);
            // this.props.getTagGroupDetailSku(id);
        }
        this.props.getProvinces();
        this.props.getListLocations({
            orderByDesc: false,
            pageIndex: 0,
            pageSize: 100,
            isDomestic: true,
        });
    }

    onChangeDetail = (fieldName, value) => {
        const hotel = this.state.hotel;
        hotel[fieldName] = value;
        this.setState({ hotel });
    };

    onChangeNapasReconEmail = (value) => {
        this.setState({ napasReconEmail: value });
    };

    getNapasReconEmail = (propertyId) => {
        if (!propertyId) return;
        getNapasReconEmailConfig({ propertyId })
            .then(config => this.setState({ napasReconEmail: config?.emails || undefined }))
            .catch(() => { });
    };

    saveNapasReconEmail = (propertyId) => {
        if (!propertyId) return Promise.resolve();
        return updateNapasReconEmailConfig({ propertyId, emails: this.state.napasReconEmail || '' })
            .catch(error => {
                message.error(error?.message || i18n.t('validation.statusCode.code.500'));
            });
    };

    onChangeTags = (fieldName, value, index) => {
        const tagGroups = this.state.tagGroups;
        if (fieldName === 'isActiveListing') {
            tagGroups[index][fieldName] = value;
        }
        this.setState({ tagGroups });
    }

    setHotelDetail = (hotelDetail) => {
        const hotel = cloneDeep(hotelDetail);
        if (this.basicInfoRef.current && this.basicInfoRef.current.setDescription && hotelDetail.description) {
            this.basicInfoRef.current.setDescription(hotelDetail.description)
        }
        this.setState({ hotel, action: hotel.id ? DETAIL_ACTIONS.UPDATE : this.state.action });

    }

    setDataGroupTagDetail = (tagsGruop) => {
        const tagsGroupChange = (tagsGruop || []).filter(item => item).map(item => {
            return {
                name: item.name,
                tagGroupDetailId: item.id,
                skuId: item.tagGroupDetailSkus?.[0]?.skuId,
                isActiveListing: item.tagGroupDetailSkus?.[0]?.isActiveListing
            }
        })
        this.setState({ tagGroups: tagsGroupChange })
    }

    onSelectPlace = (placeData) => {
        const { generalState } = this.props;
        const hotel = this.state.hotel;
        hotel.address = placeData.address;
        hotel.setPosition({ lat: placeData.lat, lng: placeData.lng });
        hotel.country = placeData.place.address_components[placeData.place.address_components.length - 1].long_name || hotel.country;
        hotel.province = getProvinceByName(placeData.address, generalState.provinces);
        if (!hotel.province) {
            hotel.province = getProvinceByName(placeData.place.address_components[placeData.place.address_components.length - 2].long_name, generalState.provinces);
        }
        this.setState({ hotel });
    }

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else {
                this.updateHotelDetail()
            }
        }
    };

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.HOTEL.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { hotel } = this.state;
        // const {tagGroups} = this.props.hotelState;
        hotel.setTranslate(language.code);
        hotel.setData();
        // tagGroups.setTranslate(language.code);
        // tagGroups.setData();
        this.setState({ hotel, action: DETAIL_ACTIONS.TRANSLATE });
        this.tagGroupDetailTranslate(language);
    }

    tagGroupDetailTranslate = (language) => {
        // const { tagGroups } = this.props.hotelState;
        // let newGroupTags = tagGroups;
        // if(language && tagGroups){
        //     newGroupTags = (tagGroups || []).map(item => item.setTranslate(language))
        // }
        // this.setDataGroupTagDetail(newGroupTags);
    }

    onExitTranslate = () => {
        const hotel = cloneDeep(this.state.hotel);
        const action = DETAIL_ACTIONS[hotel.id ? 'UPDATE' : 'CREATE'];
        hotel.setTranslate(undefined, true);
        hotel.setData();
        this.tagGroupDetailTranslate(undefined);
        this.setState({ hotel, action });
    }

    onSaveTranslate = () => {
        const { hotel } = this.state;
        const translateFunction = hotel.translate.id ? this.props.updateHotelTranslate : this.props.createHotelTranslate;
        translateFunction(hotel, hotel.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { hotel } = this.state;
        hotel.setTranslate(language.code);
        this.props.deleteHotelTranslate(hotel, { id: hotel.id });
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.hotel.name`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.hotel.code`)),
                star: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.hotel.star`)),
                locationId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.hotel.location`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        if (this.state.hotel.installmentFee || this.state.hotel.installmentLimit) {
            validate.required.installmentFee = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentFee`))
            validate.required.installmentLimit = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentLimit`))
        }
        let valueValidate = {

        };
        const napasResult = Func.multipleValidate(
            { napasReconEmail: this.state.napasReconEmail },
            { isEmailList: { napasReconEmail: t('validation.email') } }
        );
        const result = Func.multipleValidate(this.state.hotel, validate, valueValidate);
        const validation = { ...result, ...napasResult };
        this.setState({ validation });
        return Object.keys(validation).length < 1;
    }

    processUploadedFiles(fileObj) {
        let uploadFiles = this.state.uploadFiles;
        const hotel = this.state.hotel;
        hotel.addMedia(get(fileObj, 'data.fileUrl'), get(fileObj, 'data.fileName'))
        this.setState({ hotel, uploadFiles });
    }

    onUploadImages = (file) => {
        let fileData = file.target.files;
        let uploadFiles = this.state.uploadFiles;
        if (fileData.length > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        } else if ((uploadFiles.length + fileData.length) > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        }
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        Object.keys(fileData).map((i) => {
            if (imageValidation.includes(fileData[i].type)) {
                this.props.onUploadFile({ file: fileData[i], directory: UPLOAD_DIRECTORY.HOTEL, isFile: 2 })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    }

    onClickManageRoomTypes = () => {
        const { hotel } = this.state;
        const path = Func.getPathWithParams(PATHS.ROOM_TYPE.LIST.path, { hotel_id: hotel.id });
        this.props.history.push(path);
    }

    onClickManageCustomPrices = () => {
        const { hotel } = this.state;
        const path = Func.getPathWithParams(PATHS.CUSTOM_PRICE.LIST.path, { hotel_id: hotel.id });
        this.props.history.push(path);
    }

    onClickManageRates = () => {
        const { hotel } = this.state;
        const path = Func.getPathWithParams(PATHS.RATE.LIST.path, { hotel_id: hotel.id });
        this.props.history.push(path);
    }

    onClickManageBookablePackageRates = () => {
        const { hotel } = this.state;
        const path = Func.getPathWithParams(PATHS.BOOKABLE_PACKAGE_RATE.LIST.path, { hotel_id: hotel.id });
        this.props.history.push(path);
    }

    onClickRateCompare = () => {
        const { hotel } = this.state;
        const path = Func.getPathWithParams(PATHS.RATE_COMPATE.LIST.path, { hotel_id: hotel.id });
        this.props.history.push(path);
    }

    removeImages = (i, k) => {
        if (!i) return;
        const hotel = this.state.hotel;
        hotel.removeMedia(i)
        this.setState({ hotel });
    };

    updateHotelDetail() {
        const { hotel, action, tagGroups } = this.state;
        if (action === DETAIL_ACTIONS.CREATE) {
            this.props.createHotelDetail(hotel, {
                onSuccess: (createdHotel) => this.saveNapasReconEmail(createdHotel?.id)
            });
            return;
        }
        this.props.updateHotelDetail(hotel);
        this.saveNapasReconEmail(hotel.id);
        // if(action === DETAIL_ACTIONS.UPDATE){
        //     this.props.updateTagGroupDetailSkuActive(tagGroups, hotel.id)
        // }
    }

}
